module.exports = __webpack_public_path__ + "img/31.0e8b5986.png";